import { UserStats, Activity } from '@/types';

export class StatsDashboard {
  private element: HTMLElement;

  constructor(private stats: UserStats, private activities: Activity[]) {
    this.element = document.createElement('div');
    this.render();
  }

  private render(): void {
    const pointsForNextLevel = (this.stats.level * 100) - this.stats.totalPoints;
    const progressPercentage = ((this.stats.totalPoints % 100) / 100) * 100;

    this.element.className = 'stats-dashboard mb-6';
    this.element.innerHTML = `
      <div class="grid grid-3 gap-4">
        <div class="card p-6 text-center">
          <div class="text-3xl font-bold mb-3" style="color: var(--accent);">
            ${this.stats.totalPoints}
          </div>
          <div class="text-sm font-medium" style="color: var(--text-primary);">Total Points</div>
          <div class="mt-4">
            <div class="progress-bar">
              <div class="progress-fill" style="width: ${progressPercentage}%"></div>
            </div>
            <div class="text-xs mt-2" style="color: var(--text-secondary);">
              ${pointsForNextLevel} points to Level ${this.stats.level + 1}
            </div>
          </div>
        </div>
        
        <div class="card p-6 text-center">
          <div class="text-3xl font-bold mb-3" style="color: #48bb78;">
            ${this.stats.currentStreak}
          </div>
          <div class="text-sm font-medium" style="color: var(--text-primary);">Current Streak</div>
          <div class="text-xs mt-2" style="color: var(--text-secondary);">
            Best: ${this.stats.longestStreak} days
          </div>
        </div>
        
        <div class="card p-6 text-center">
          <div class="text-3xl font-bold mb-3" style="color: #5a67d8;">
            ${this.stats.activitiesCompleted}
          </div>
          <div class="text-sm font-medium" style="color: var(--text-primary);">Activities Completed</div>
          <div class="text-xs mt-2" style="color: var(--text-secondary);">
            ${this.activities.filter(a => a.isActive).length} active activities
          </div>
        </div>
      </div>
    `;
  }

  public updateStats(stats: UserStats, activities: Activity[]): void {
    this.stats = stats;
    this.activities = activities;
    this.render();
  }

  public getElement(): HTMLElement {
    return this.element;
  }
}